import { GAG_TRACKS } from '../data/gags';
import { gagImageContext, getImageFromContext } from './images';

export const getGagInfo = (gag) => {
  if (!gag) return null;
  const track = GAG_TRACKS[gag.track - 1];
  const gagInfo = track?.gags?.[gag.level - 1];
  if (!track || !gagInfo) return null;
  return {
    track: gag.track,
    level: gag.level,
    trackName: track.name,
    gagName: gagInfo.name,
    file: gagInfo.file,
    targeting: gagInfo.targeting ?? null,
    min: gagInfo.min ?? null,
    max: gagInfo.max ?? null,
    organicMin: gagInfo.organicMin ?? null,
    organicMax: gagInfo.organicMax ?? null,
    roundsLured: gagInfo.roundsLured ?? null,
    organicAccuracyBonus:
      gagInfo.organicAccuracyBonus ?? track.organicAccuracyBonus ?? null,
    kind: gagInfo.kind ?? null,
    accuracy: gagInfo.accuracy ?? track.accuracy ?? null,
  };
};

export const getGagImageSrc = (file) => {
  return getImageFromContext(gagImageContext, file);
};

export const getGagPowerRange = (toon, gagInfo) => {
  if (!gagInfo) return { min: null, max: null };
  const baseMin = gagInfo.min ?? null;
  const baseMax = gagInfo.max ?? null;
  return {
    min:
      toon.organic && gagInfo.organicMin != null ? gagInfo.organicMin : baseMin,
    max:
      toon.organic && gagInfo.organicMax != null ? gagInfo.organicMax : baseMax,
  };
};

export const getGagPower = (toon, gagInfo) => {
  const { min, max } = getGagPowerRange(toon, gagInfo);
  if (max == null) return null;
  const gagLevel = toon.gag?.level ?? null;
  const showUnmaxed = Boolean(toon.gag && gagLevel < 7);
  const canAdjustPower =
    showUnmaxed &&
    toon.unmaxed &&
    min != null &&
    max != null &&
    min !== max &&
    (gagLevel === 6 || toon.highestGagLevel === gagLevel);
  if (canAdjustPower && toon.gagPower != null) {
    return Math.min(Math.max(toon.gagPower, min), max);
  }
  return max;
};

export const getGagAccuracy = (toon, gagInfo) => {
  if (!gagInfo?.accuracy) return null;
  if (gagInfo.trackName === 'Trap') return gagInfo.accuracy;
  const gagLevel = toon.gag?.level ?? null;
  const effectiveHighestLevel = toon.gag
    ? toon.unmaxed
      ? Math.min(toon.highestGagLevel ?? gagLevel ?? 1, 7)
      : 7
    : null;
  const accuracyStep = gagInfo.trackName === 'Toon-Up' ? 5 : 10;
  const accuracyBonus =
    Math.max((effectiveHighestLevel ?? 1) - 1, 0) * accuracyStep;
  const organicAccuracyBonus =
    toon.organic && gagInfo.trackName === 'Lure'
      ? gagInfo.organicAccuracyBonus ?? 0
      : 0;
  return gagInfo.accuracy + accuracyBonus + organicAccuracyBonus;
};
